import VolmaFile from "./VolmaFile"

export default VolmaFile;